<db-switch-plan-annual
  *ngIf="!showCheckout"
  @slide
  [userSubscription]="userSubscription"
  [annualSubscription]="annualSubscription"
  [monthlyPrice]="monthlyPrice"
  [annualPriceForCurrent]="annualPriceForCurrent"
  [visitors]="visitors" [ssdStorage]="ssdStorage"
  [annualVisitors]="annualVisitors" [annualSsdStorage]="annualSsdStorage"
  [annualPrice]="annualSubscription?.plan?.planPrice"
  [switchToAnnual]="switchToAnnual"
  (onClickAction)="showCheckout = true">
</db-switch-plan-annual>
<db-switch-plan-checkout
  *ngIf="!!showCheckout"
  @slide
  [demoUser]="demoUser"
  [userSubscription]="userSubscription" [annualSubscription]="annualSubscription"
  [annualVisitors]="annualVisitors" [annualSsdStorage]="annualSsdStorage"
  [visitors]="visitors" [ssdStorage]="ssdStorage"
  (onClose)="closeModal($event)">
</db-switch-plan-checkout>
